import { render, staticRenderFns } from "./AsideBlog.vue?vue&type=template&id=0cd40540&"
import script from "./AsideBlog.vue?vue&type=script&lang=js&"
export * from "./AsideBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports